<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="6">
            <!-- ID Tenant -->
            <validation-provider
              #default="validationContext"
              name="tenant"
              rules="required"
            >
              <b-form-group
                :label="$t('unit.tenant')"
                label-for="id_tenant"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_tenant"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="tenantOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  @input="changeTenant()"
                  input-id="id_tenant"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <validation-provider #default="validationContext" name="Center" rules="required">
              <b-form-group
                :label="$t('unit.center')"
                label-for="id_center"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_center"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="centerOptions"
                  :reduce="(val) => val.value"
                  input-id="id_center"
                  @input="changeCenter()"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <validation-provider #default="validationContext" name="Sector">
              <b-form-group
                :label="$t('unit.sector')"
                label-for="id_sector"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_sector"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="sectorOptions"
                  :reduce="(val) => val.value"
                  input-id="id_sector"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- country -->
            <validation-provider
              #default="validationContext"
              name="id_country"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$tc('country.title', 1)"
                label-for="id_country"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_country"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="countryOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_country"
                  @input="changeCountry"
                  :disabled="countryOptions.length === 1"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- region -->
            <validation-provider
              #default="validationContext"
              name="id_region"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$tc('region.title', 1)"
                label-for="id_estado"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_region"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="regionOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_estado"
                  @input="changeRegion"
                  :disabled="!itemData.id_country"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- municipality -->
            <validation-provider
              #default="validationContext"
              name="id_municipality"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$tc('municipality.title', 1)"
                label-for="id_municipality"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_municipality"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="municipalityOptions"
                  :clearable="true"
                  :reduce="(val) => val.value"
                  input-id="id_municipality"
                  :disabled="!itemData.id_region"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Suburb Colonia -->
            <validation-provider
              #default="validationContext"
              name="suburb"
              v-if="$can('advance_setting', 'Unit')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.suburb')"
                label-for="suburb"
              >
                <b-form-input
                  id="suburb"
                  v-model="itemData.suburb"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Direccion 1 -->
            <validation-provider #default="validationContext" name="address_1">
              <b-form-group
                class="text-capitalize"
                label-for="address_1"
              >
                <template #label>
                  {{ $t('unit.address_1') }}
                  <span id="placeholders-help">
                    <feather-icon icon="HelpCircleIcon" size="16" />
                  </span>
                </template>
                <b-form-input
                  id="address_1"
                  v-model="itemData.address_1"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>

              <b-tooltip target="placeholders-help" placement="right">
                {{ $t("unit.correct_address_warning") }}
              </b-tooltip>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- reference -->
            <validation-provider #default="validationContext" name="address_2">
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.address_2')"
                label-for="address_2"
              >
                <b-form-input
                  id="address_2"
                  v-model="itemData.address_2"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- CP -->
            <validation-provider #default="validationContext" name="postal_code">
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.postal_code')"
                label-for="postal_code"
              >
                <b-form-input
                  id="postal_code"
                  v-model="itemData.postal_code"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <!-- Número -->
            <validation-provider
              #default="validationContext"
              name="number"
              required="true"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.number')"
                label-for="number"
              >
                <b-form-input
                  id="number"
                  v-model="itemData.number"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <!-- exterior number -->
            <validation-provider
              #default="validationContext"
              name="exterior_number"
              v-if="$can('advance_setting', 'Unit')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.exterior_number')"
                label-for="exterior_number"
              >
                <b-form-input
                  id="exterior_number"
                  v-model="itemData.exterior_number"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="align-items-end">
          <b-col cols="3">
            <!-- Latitud -->
            <validation-provider
              #default="validationContext"
              name="lat"
              rules="required|between:-90,90"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('router.latitude')"
                label-for="lat"
              >
                <b-form-input
                  id="lat"
                  v-model="itemData.lat"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <small class="form-text text-muted">
                  -90 | 90
                </small>

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="3">
            <!-- Longitud -->
            <validation-provider
              #default="validationContext"
              name="lng"
              rules="required|between:-180,180"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('router.longitude')"
                label-for="lng"
              >
                <b-form-input
                  id="lng"
                  v-model="itemData.lng"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <small class="form-text text-muted">
                  -180 | 180
                </small>

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="4">
            <b-form-group
              class="text-capitalize"
              :label="$t('unit.timeZone')"
              label-for="timeZone"
            >
              <v-select
                label="name"
                v-model="itemData.time_zone"
                :options="timezoneOptions"
                :clearable="true"
                :reduce="(val) => val.name"
                input-id="id_tenant"
              />
              <small id="timeZone" class="form-text text-muted">
                {{ $t("unit.example") }}: America/New_York
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="2" class="d-flex align-items-center ">
            <b-button
              variant="primary"
              class="btn-sm text-capitalize my-2"
              @click="applyReverseGeocoder()"
            >
              {{ $t('unit.getLatLng') }}
            </b-button>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col cols="12">
            <b-img-lazy center :src="itemData.img_unit" fluid alt="Totem img" class="u-height-max-400 my-2"></b-img-lazy>
          </b-col>
        </b-row> -->
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BFormRadio,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import formValidation from "@core/comp-functions/forms/form-validation";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { required, alphaNum, email, positive, required_if } from "@validations";
import { computed,ref, onMounted, watch } from "@vue/composition-api";
import { Loader } from "@googlemaps/js-api-loader";
import store from "@/store";
import { getCspNonce } from "@/utils/cspNonce";

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    BFormRadio,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
    propItemData: {
      type: Object,
      required: true,
    },
    tenantOptions: {
      type: Array,
      required: true,
    },
    countryOptions: {
      type: Array,
      required: true,
    },
    regionOptions: {
      type: Array,
      required: true,
    },
    municipalityOptions: {
      type: Array,
      required: true,
    },
    // centerOptions:{
    //   type: Array,
    //   require: true
    // },
    timezoneOptions: {
      type: Array,
      require: true
    }
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));
    const toast = useToast();
    const { t } = useI18nUtils();

    const centerOptions = computed(() => store.getters['center/getSelectedItems']);

    const sectorOptions = computed(() => store.getters['sector/getSelectedItems']);

    const trans = {
      "unit.no_result_found": t("unit.no_result_found"),
      "unit.reverse_geocoder_failed": t("unit.reverse_geocoder_failed"),
    };

    let geocoder = null;

    onMounted(async () => {
      const loader = new Loader({
        apiKey: window.__env.VUE_APP_GMAPS_KEY,
        version: "beta",
        libraries: ["marker", "places", "drawing"],
        language: "en",
        nonce: getCspNonce(),
      });

      await loader.load();

      geocoder = new google.maps.Geocoder();

      if (props.isAdd && !itemData.value.id_tenant && props.tenantOptions.length > 0) {
        itemData.value.id_tenant = props.tenantOptions[0].value;
      }

      // El centro ya no depende del tenant: se cargan todos los centros.
      store.dispatch("center/getAll");
    });

    const changeCenter = () => {
      itemData.value.id_sector = null;
      // El sector ya no depende del tenant: se carga en función del centro.
      if (itemData.value.id_center) {
        store
          .dispatch("sector/getAll", {
            id_center: [itemData.value.id_center],
          })
      }
    }

    const changeTenant = () => {
      // El centro ya no depende del tenant, por lo que cambiar de tenant
      // no recarga ni reinicia la selección de centro.
    };

    watch(
      () => centerOptions.value,
      (options) => {
        if (props.isAdd && !itemData.value.id_center) {
          itemData.value.id_sector = null;
          if (options && options.length > 0) {
            itemData.value.id_center = options[0].value;
          } else {
            itemData.value.id_center = 0;
          }
          changeCenter();
        } else {
          if (options && options.length > 0 && itemData.value.id_center) {
            store.dispatch("sector/getAll", { id_center: [itemData.value.id_center] });
          }
        }
      },
      { immediate: true }
    );

    watch(
      () => sectorOptions.value,
      (options) => {
        if (props.isAdd && !itemData.value.id_sector && options && options.length > 0) {
          itemData.value.id_sector = options[0].value;
        }
      },
      { immediate: true }
    );

    watch(
      () => props.countryOptions,
      (options) => {
        if (!options || !options.length) return;

        if (options.length === 1) {
          itemData.value.id_country = options[0].value;
          changeCountry();
          return;
        }

        const valid = options.map((o) => o.value);
        if (
          itemData.value.id_country &&
          !valid.includes(itemData.value.id_country)
        ) {
          const derived =
            itemData.value.country?.id ?? itemData.value.region?.country_id ?? null;
          itemData.value.id_country = valid.includes(derived) ? derived : null;
          if (itemData.value.id_country) changeCountry();
        }
      },
      { immediate: true }
    );

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    const changeCountry = () => {
      store
        .dispatch("region/getAll", {
          id_country: [itemData.value.id_country],
        })
        .then(() => {
          const region = props.countryOptions.filter(
            (item) => item.value == itemData.value.id_region
          );

          if (region.length == 0 && itemData.value.id_region) {itemData.value.id_region = null};

          changeRegion();
        });
    };

    const changeRegion = () => {
      store
        .dispatch("municipality/getAll", {
          region: [itemData.value.id_region],
        })
        .then(() => {
          const municipality = props.regionOptions.filter(
            (item) => item.value == itemData.value.id_municipality
          );
          //console.log('changeRegion-Municipality:', municipality )
          if (municipality.length == 0  && itemData.value.id_municipality) itemData.value.id_municipality = null;
        });
    };

    const applyReverseGeocoder = () => {
      let region = props.regionOptions.filter(
        (region) => region.value == itemData.value.id_region
      );
      let address = `${itemData.value.address_1}, ${itemData.value.postal_code}, ${region[0].label}`;
      geocoder
        .geocode({ address: address })
        .then(async (response) => {
          if (response.results[0]) {
            itemData.value.lat = response.results[0].geometry.location.lat();
            itemData.value.lng = response.results[0].geometry.location.lng();

            const timestamp = Math.floor(Date.now() / 1000);
            const tzRes = await fetch(
              `https://maps.googleapis.com/maps/api/timezone/json?location=${itemData.value.lat},${itemData.value.lng}&timestamp=${timestamp}&key=${window.__env.VUE_APP_GMAPS_KEY}`
            );
            const tzData = await tzRes.json();
            itemData.value.time_zone = tzData.timeZoneId;
          } else {
            toast({
              component: ToastificationContent,
              props: {
                title: trans["unit.no_result_found"],
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((e) => {
          toast({
            component: ToastificationContent,
            props: {
              title: trans["unit.reverse_geocoder_failed"],
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = { ...newValue };
      },
      { deep: true }
    );

    setupWatcher(itemData, "id_tenant");
    setupWatcher(itemData, "id_country");
    setupWatcher(itemData, "id_region");
    setupWatcher(itemData, "id_municipality");
    setupWatcher(itemData, "address_1");
    setupWatcher(itemData, "address_2");
    setupWatcher(itemData, "exterior_number");
    setupWatcher(itemData, "suburb");
    setupWatcher(itemData, "number");
    setupWatcher(itemData, "postal_code");
    setupWatcher(itemData, "lat");
    setupWatcher(itemData, "lng");
    setupWatcher(itemData, "alt");
    setupWatcher(itemData, "time_zone");
    setupWatcher(itemData, "img_unit");
    setupWatcher(itemData, "id_unit");
    setupWatcher(itemData, "id_center");
    setupWatcher(itemData, "id_sector");

    return {
      required,
      alphaNum,
      email,
      positive,
      required_if,
      itemData,
      refFormObserver,
      getValidationState,
      validateStep,
      changeCountry,
      changeRegion,
      applyReverseGeocoder,
      sectorOptions,
      changeCenter,
      changeTenant,

      centerOptions
    };
  },
};
</script>
